baseApp.component('sticky', {
	bindings: {
		stickyEl: '<',
		contentEl: '<',
		defaultTop: '<',
		marginTop: '<',
		setHeaderWidth: '@',
	},
	controller: function ($scope, $timeout, $interval) {
		const ctrl = this;
		const DEFAULT_TOP = 60;
		const $window = $(window);

		let scrollInterval;
		let scrollTimeout;
		let originalPosition;

		ctrl.$postLink = () => {
			setHeaderStickiness();
		};

		ctrl.$onChanges = () => {
			setHeaderStickiness();
		};

		function setHeaderStickiness() {
			if (scrollTimeout) {
				$timeout.cancel(scrollTimeout);
			}
			scrollTimeout = $timeout(function () {
				if (!ctrl.stickyEl || ctrl.stickyEl.length == 0 || !ctrl.contentEl || ctrl.contentEl.length == 0) {
					return;
				}

				const chartDivMiddle = ctrl.stickyEl.offset().top - DEFAULT_TOP;
				let didScroll = false;
				let lastTop = 0;
				if (!ctrl.stickyEl.hasClass('fixed') && $window.scrollTop() > chartDivMiddle) {
					shrinkChart();
				}

				if (scrollInterval) {
					$interval.cancel(scrollInterval);
				}
				scrollInterval = $interval(function () {
					if (didScroll) {
						var currentScroll = $window.scrollTop();
						if (!ctrl.stickyEl.hasClass('fixed') && currentScroll > chartDivMiddle) {
							shrinkChart();
						} else if (ctrl.stickyEl.hasClass('fixed')) {
							lastTop = ctrl.contentEl.height() + 20;
							if (currentScroll < chartDivMiddle) {
								unShrinkChart();
							} else if (currentScroll > lastTop) {
								fixChartMaxTop();
							} else {
								unFixChartMaxTop();
							}

						}
						if (ctrl.setHeaderWidth) {
							ctrl.setHeaderWidth();
						}
						didScroll = false;
					}
				}, 30, false);

				$window.scroll(setScroll);

				function setScroll() {
					didScroll = true;
				}

				function unFixChartMaxTop() {
					ctrl.stickyEl.css('top', getTop());
				}

				function fixChartMaxTop() {
					ctrl.stickyEl.css('top', lastTop + 20);
				}

				function shrinkChart() {
					ctrl.stickyEl.css('top', getTop());
					ctrl.stickyEl.addClass('fixed');
					originalPosition = ctrl.stickyEl.css('position');
					ctrl.stickyEl.css({position: 'fixed'});
					ctrl.contentEl.css('marginTop', 100);
				}

				function unShrinkChart() {
					ctrl.stickyEl.css('top', 0);
					ctrl.stickyEl.removeClass('fixed');
					ctrl.stickyEl.css({position: originalPosition});
					ctrl.contentEl.css('marginTop', 0);
				}
			}, 1, false);

		}

		function getTop() {
			return ctrl.defaultTop || DEFAULT_TOP + (ctrl.marginTop || 0);
		}

		ctrl.$onDestroy = () => {
			if (scrollInterval) {
				$interval.cancel(scrollInterval);
			}
			if (scrollTimeout) {
				$timeout.cancel(scrollTimeout);
			}

			$window.off('scroll');
		}
	}
});
